var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 4.66797H3.66675C3.40153 4.66797 3.14718 4.77333 2.95964 4.96086C2.7721 5.1484 2.66675 5.40275 2.66675 5.66797C2.66675 5.93319 2.7721 6.18754 2.95964 6.37508C3.14718 6.56261 3.40153 6.66797 3.66675 6.66797H4.33341C4.59863 6.66797 4.85299 6.77333 5.04052 6.96086C5.22806 7.1484 5.33341 7.40275 5.33341 7.66797C5.33341 7.93319 5.22806 8.18754 5.04052 8.37508C4.85299 8.56261 4.59863 8.66797 4.33341 8.66797H2.66675",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 11.3333H10.6667M8 8.66667H10.6667M4 4.66667V4M4 9.33333V8.66667",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2H12.6667C12.8435 2 13.013 2.07024 13.1381 2.19526C13.2631 2.32029 13.3333 2.48986 13.3333 2.66667V13.3333C13.3333 13.5101 13.2631 13.6797 13.1381 13.8047C13.013 13.9298 12.8435 14 12.6667 14H4.66667C4.48986 14 4.32029 13.9298 4.19526 13.8047C4.07024 13.6797 4 13.5101 4 13.3333V12",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceDollar);
export default __webpack_public_path__ + "static/media/invoice-dollar.63dcbfaaa7ea8f857f25266f2b28d16a.svg";
export { ForwardRef as ReactComponent };